"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const useKeyboardSelect_1 = __importDefault(require("./useKeyboardSelect"));
function useAutocomplete(config) {
    const { inputRef: originalInputRef, onInputChange = noop_1.default, inputValue, options, onSelectOption, } = config;
    const alternativeInputRef = (0, react_1.useRef)(null);
    const inputRef = originalInputRef ? originalInputRef : alternativeInputRef;
    const valueRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(inputValue);
    const { focused } = (0, libs_hooks_dom_1.useWatchingFocus)(inputRef);
    const [showOptions, openOptions, closeOptions] = (0, libs_hooks_react_1.useToggleState)(true);
    const onInputChangeHandler = (event) => {
        onInputChange(event.target.value);
    };
    const { selectedItem } = (0, useKeyboardSelect_1.default)(options, {
        focused,
        onSelectItem: onSelectOption,
        onOpenOptions: openOptions,
        onCloseOptions: closeOptions,
        showOptions: showOptions,
    });
    return {
        inputRef,
        inputValue: valueRef.current ? valueRef.current : '',
        selectedItem: selectedItem.current,
        onInputChange: onInputChangeHandler,
        showOptions,
        openOptions,
        closeOptions,
    };
}
exports.default = useAutocomplete;
//# sourceMappingURL=useAutocomplete.js.map